<template>
  <div class="angel-fund-project-list">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <div class="radiobut" v-if="permission.otherSubFundManage_audit">
      <!-- <el-badge :value="examinelist" class="examine_length"> -->
      <el-radio-group v-model="margintap" >
        <el-radio-button :disabled="loading" label="0">全部子基金</el-radio-button>
        <!-- <el-badge v-if="permission.otherSubFunds_audit" :value="auditNumber" class="examine_length">
          <el-radio-button :disabled="loading" :class="[center_radio,{'right_radio':!permission.otherSubFundManage_audit}]" label="1">子基金审核</el-radio-button>
        </el-badge> -->
        <el-badge v-if="permission.otherSubFundManage_audit" :value="examinelist" class="examine_length">
          <el-radio-button :disabled="loading"  class="right_radio" label="2">填报审核</el-radio-button>
        </el-badge>
      </el-radio-group>
      <!-- </el-badge> -->
    </div>

    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        :summary-method="summaryMethod"
        :class="[{'avue_no_index':margintap != 2}]"
      >
      <template slot="search">
          <div class="block" v-if="margintap == 0">
            <el-form-item label="设立时间">
              <el-date-picker
                v-model="timepic"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </template>
        
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="permission.otherSubFunds_add && margintap == 0"
            @click.stop="handleAdd()"
            >新建子基金
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="permission.otherSubFunds_edit && margintap == 0"
            :disabled="disabled || selectionList.length > 1"
            @click.stop="handleEdit()"
            >编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.otherSubFunds_del && margintap == 0"
            :disabled="disabled"
            @click.stop="handleDel()"
            >删除
          </el-button>
          <el-button
            size="small"
            plain
            @click="exportShow"
            icon="el-icon-download"
            v-if="margintap == 0"
          >
            导出数据
          </el-button>
        </template>
        <template slot="fundDetail" slot-scope="{ row }">
          <div class="fund-detail">
            <span v-if="!row['eventNum'] || row['eventNum'] == 0" class="gray-text">暂无</span>
            <span v-else class="blue-text">{{row.eventNum}}个明细</span>
            <a-popover
              placement="right"
              trigger="hover">
              <template slot="content">
                <div class="fund-right-content" >
                  <el-button class="right-btn" type="text" size="small" @click="goAddEvent(3, row)">出资动态</el-button>
                  <el-button class="right-btn" type="text" size="small" @click="goAddEvent(4, row)">分配动态</el-button>
                </div>
              </template>
              <i  class="el-icon-plus plus-right" style="cursor:pointer;"></i>
            </a-popover>
          </div>
        </template>
        <template slot="name" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.name||row.fundName }}
          </div>
        </template>
      </avue-crud>
    </div>
    <el-dialog
      :close-on-click-modal="false" 
      :title="dialogTitle"
      :visible.sync="dialogVisibles"
      width="75%"
    >
      <InvestEventAdd
        ref="eventAdd"
        :isDetail="isDetail"
        :id="projectId"
        :addType="addType"
        eventBelongType="2"
        :eventId="eventId"
        @addSuccess="addSuccess"
      />
    </el-dialog>  
    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import { subFundListConfig } from "./config.js";
import ExportData from "@/components/exportData/exportData";
import {
  getSubFundList,
  getSubFundListTotal,
  getSubFundClientList,
  deleteFdsbasicinfo,
} from "@/api/fund/subfunds";
import { downLoadTemplate } from "@/router/downLoadTem";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import { mapGetters } from "vuex";
import InvestEventAdd from "@/components/fundComponent/investEventAdd"

export default {
  name: "SubFundsList",
  data() {
    return {
      projectId: '',
      isDetail: false,
      dialogTitle: '',
      eventId: '',
      dialogVisibles: false,
      addType: '',  
      totalData: '',
      examinelist: 0,
      auditNumber: 0,
      margintap: "0",
      files: [],
      tableData: [],
      selectionList: [],
      tableConfig: subFundListConfig(this.getMoney),
      searchForm: {},
      contractParam: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      timepic:[],
      disabled: true,
      editDisabled:true,
      loading:false
    };
  },
  watch: {
    margintap: {
      handler(newValue, oldValue) {
        this.loading=true
        this.showColumn();
        if (this.margintap == 0) {
          this.queryTableData();
        } else if (this.margintap == 1) {
          this.queryTableAuditData();
        } else {
          this.queryAuditNum();
        }
      },
      // immediate:true
    },
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return (
            this.userInfo.user_id == item.managerUser 
            // && 0 == item.auditState
          );
        });
        // let editList = data.filter((item) => {
        //   return (
        //     this.userInfo.user_id == item.managerUser 
        //     && 1!= item.auditState
        //   );
        // });
        // this.editDisabled = editList.length != data.length || data.length == 0;
        this.disabled=false
        // this.disabled = list.length != data.length || data.length == 0;v
      },
      deep: true,
    },
    timepic: {
      handler(newName, oldName) {
        if (newName != undefined&&newName.length>0) {
          (this.searchForm.establishmentTimeBegin = this.timepic[0]),
            (this.searchForm.establishmentTimeEnd = this.timepic[1]);
        }
      },
      deep:true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  components: {
    TagsCloud,
    ExportData,
    InvestEventAdd,
  },
  mounted() {
    this.showColumn();
  },
  methods: {
    summaryMethod({ columns, data }) {
      const self = this
      const sums = [];
      let arrays = ['govIndustrySubscribed','govIndustrySubscribed']
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(column.property)) {
            // 赋值totalData
            sums[index] = self.getMoney(Math.round(Number(self.totalData[column.property])/10000*100)/100)
          } else {
            sums[index] = "";
          }
        });
      }
      sums[1]="合计:"
      return sums;
    },    


    goAddEvent(type, row) {
      // if(row.managerUser!=this.userInfo.user_id){
      //     this.$message({
      //     type: "warning",
      //     message: "您暂无权限进行此操作，请核对是否为其基金对接人。",
      //     });
      //     return
      // }
        this.isDetail = false
        this.dialogTitle = type==3?'新增出资动态':type==4?'新增分配动态':''
        this.eventId = ''
        this.projectId = row.id
        this.addType = type
        if(this.$refs.eventAdd){
          this.$refs.eventAdd.cleanData()
        }
        this.dialogVisibles = true
    },

    addSuccess() {
      this.queryTableData()
      this.dialogVisibles = false
    },

    showColumn() {
      this.tableConfig.showSummary=this.margintap == 2?false:true
      this.tableConfig.column.filter((item) => {
        if (item.prop == "auditState") {
          item.hide = this.margintap == 0 ? false : true;
        }
        if(item.prop =="fundDetail"){
            item.hide=this.margintap == 2?true:false
        
          }  
      });
    },
    //选择项发生变化 传入数组
    selectionChange(list) {
      this.selectionList = list;
    },
    handleAdd(data) {
      this.$router.push({
        path: "/otherFund/subFunds/add/-1",
      });
    },
    handleEdit() {
      let data = this.selectionList[0];
      this.$router.push({
        path: `/otherFund/subFunds/edit/${data.id}`,
      });
    },
    handleDel() {
      let self = this;
      if (this.selectionList.length > 0) {
        let index = 0;

        this.selectionList.map((item) => {
          if (item.managerUser == this.userInfo.user_id) {
            index += 1;
          }
        });

        if (index != this.selectionList.length) {
          this.$message.warning("您没有权限删除此条数据");
          return;
        }
        this.$confirm("确定删除选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let ids = this.selectionList.map((item) => {
              return item.id;
            });

            let res = await deleteFdsbasicinfo({
              ids: ids.join(","),
            });
            if (res.data.code == 200) {
              self.$message({
                type: "success",
                message: "删除成功",
              });
              self.queryTableData();
            }
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message.error("请选择数据进行删除");
      }
    },
    searchChange(query, done) {
      this.loading=true
      this.page.currentPage = 1;
      this.searchForm = {...this.searchForm,...query};
      if (this.margintap == 0) {
        this.queryTableData();
      } else if (this.margintap == 1) {
        this.queryTableAuditData();
        
      } else {
        this.queryAuditNum();
        
      }
      done();
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        bizType:3,
        
      };
      
      if (this.margintap == 0) {
        this.queryAuditNum();
        // this.queryTableAuditData();
        this.tableConfig.selection=true
        let res = await getSubFundList(params);
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.total;
          let totalParams = {
            current: this.page.currentPage,
            size: this.page.pageSize,
            bizType: 3,
            ...this.searchForm,
          }
          let totalData = await getSubFundListTotal(totalParams)
          this.totalData = totalData.data.data          
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading=false
      } else {
        this.queryAuditNum();
        this.loading=false
      }
    },
    async queryTableAuditData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        auditState: 1,
        bizType:3,
        
      };
      
      let res = await getSubFundList(params);
      if (res.data.code == 200) {
        if (this.margintap == 1) {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.total;
          this.auditNumber = res.data.data.total;
          this.queryAuditNum();
          this.tableConfig.selection=false               
        } else {
          this.auditNumber = res.data.data.total;
        }
        this.loading=false
      } else {
        this.$message.error(res.data.msg);
        this.loading=false
      }
    },

    async queryAuditNum() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        auditState: 1,
        bizType:3,
        fundType:2,
        isServer:1

      };
     
      let res = await getSubFundClientList(params);
      if (res.data.code == 200) {
        if (this.margintap == 2) {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.total;
          this.examinelist = res.data.data.total;
          this.tableConfig.selection=false
          let totalParams = {
            current: this.page.currentPage,
            size: this.page.pageSize,
            auditState: 1,
            bizType:3,
            fundType:2,
            isServer:1
          }
          let totalData = await getSubFundListTotal(totalParams)
          this.totalData = totalData.data.data            
        } else {
          this.examinelist = res.data.data.total;
        }
        this.loading=false
      }else {
        this.$message.error(res.data.msg);
        this.loading=false
      }
    },

    searchResets() {
      this.searchForm = {};
      this.timepic = [];
      this.queryTableData();
    },

    goDetail(data) {
      if (this.margintap == 0 || this.margintap == 1) {
        this.$router.push({
          path: `/otherFund/subFunds/subFundsDetail/${data.id}`,
        });
      } else {
        this.$router.push({
          path: `/otherFund/subFunds/subFundsAuditDetail/${data.basicInfoId}`,
          query: {
            audit: "true",
          },
        });
      }
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
      let exportUrl =
        this.margintap == 0 || this.margintap == 1
          ? "/api/fds/fdsbasicinfo/export"
          : "/api/fund/fdbasicinfo/export";
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
        bizType:3
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }

      downLoadTemplate(exportUrl, data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.angel-fund-project-list {
  .blue-text{
    margin-right: 5px;
  }  
  .plus-right{
    color: #f56c6c !important;
    font-weight: 600;
    font-size: 16px;
}

  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .radiobut {
    margin: 10px 0;
  }
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  /deep/.el-badge__content {
    line-height: 17px;
    padding: 0 5px;
    z-index: 29;
  }
  .el-table__fixed, .el-table__fixed-right {
      height: calc(100% - 0px) !important;
  }
  /deep/.el-table {
    display: flex !important;
    flex-direction: column !important;
  }
  //  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 
  /deep/.el-table__body-wrapper {
    order: 1 !important;
  }

  /deep/.el-table__fixed-footer-wrapper{
    top: 40px !important;
    z-index: 0;
  }
  /deep/.avue_no_index {
    .el-table__fixed-body-wrapper{
    top: 80px !important
  }
  }
}
/deep/ .right_radio .el-radio-button__inner {
    border-left: 0;
    border-radius: 0 4px 4px 0;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;

}
/deep/ .center_radio .el-radio-button__inner {
    border-left: 0;
    border-radius: 0;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;

}
.fund-right-content {
  .right-btn {
    margin-left: 0 !important;
    margin-bottom: 10px;
    width: 100%;
    color: black;
    font-size: 14px;
  }
  .right-btn:hover {
    color: #64b0ff;
  }
}
.plus-right {
  color: #f56c6c !important;
  font-weight: 600;
  font-size: 16px;
}
/deep/.ant-popover-placement-right{
  width: 170px !important;
}
/deep/ .el-table .cell, /deep/ .el-table th>.cell {

padding-left:0px;
padding-right: 0px;

}
/deep/ .el-table .cell {
font-size:14px;

}
/deep/.el-table__footer-wrapper,/deep/.el-table__fixed-footer-wrapper {
   .cell {
      color:red
    }
 }
</style>